export enum EExerciseType {
  Count,
  React,
  Sequence,
  Agility,
  Vertical,
  Companion,
}
